import { render } from "./ContentPtBR.vue?vue&type=template&id=458f8548"
import script from "./ContentPtBR.vue?vue&type=script&lang=js"
export * from "./ContentPtBR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__